import React from 'react';
import Div from '../Div';
import Slider from 'react-slick';
import TestimonialStyle2 from '../Testimonial/TestimonialStyle2';
const testimonialData = [
  {
    avatarImgUrl: '/images/reviewimage.jpg',
    testimonialText:
      'One of the best movie theatres ever I have seen People will like the fesilities provided there and it will be one of the most amazing place to experience a movie',
    avatarName: 'Narasinghnath Pradhan ',
    // avatarDesignation: '',
    ratings: '5',
  },
  {
    avatarImgUrl: '/images/reviewimage.jpg',
    testimonialText:
      'Great ambiance... Fully supporting staffs.. Good behaviour also.. Food prices all well.. Brew coffee better than CCD and price is also affordable. Great entertainment with family',
    avatarName: 'Krushnachandra Pangi',
    avatarDesignation: '',
    ratings: '5',
  },
  {
    avatarImgUrl: '/images/reviewimage.jpg',
    testimonialText:
      'Amazing Experience overall! I am so pleased with the service. I am very impressed with the quality of this theatre, It is spacious and sounds like such a great experience.And the owner is a down to earth person ever, I have seen.',
    avatarName: 'RABINDRA NATH NAIK',
    avatarDesignation: '',
    ratings: '4',
  },
  // {
  //   avatarImgUrl: '/images/avatar_5.png',
  //   testimonialText:
  //     'I am thrilled to share my experience with poze software. Their AI solutions have truly revolutionized the way businesses operate. They have set a new standard in the industry. Highly recommended!',
  //   avatarName: 'Leonel Bolian',
  //   avatarDesignation: 'Ninja Shop',
  //   ratings: '4',
  // },
];

export default function TestimonialSliderStyle3() {
  /** Slider Settings **/
  const settings = {
    infinite: true,
    slidesToShow: 3,
    speed: 500,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <Slider {...settings} className="cs-slider cs-gap-24">
      {testimonialData.map((item, index) => (
        <Div key={index}>
          <TestimonialStyle2 {...item} />
        </Div>
      ))}
    </Slider>
  );
}
